import dayjs from 'dayjs'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import type { ScheduleItemWithConflicts } from '../Context/ScheduleItems/scheduleItemStore'
import type { DriverFormSubmit } from '../Forms/DriverScheduleItem/DriverScheduleItemForm'
dayjs.extend(utc)
dayjs.extend(tz)

export const formToScheduleItem = ({ type, ...form }: DriverFormSubmit, tz?: string): ScheduleItemWithConflicts => ({
  event_id: form.id ?? '',
  date: form.date,
  trailer_id: form.trailer_id,
  tractor_id: form.tractor_id,
  tractor_number: form.tractor_name,
  trailer_number: form.trailer_name,
  conflictingItems: [],
  errors: [],
  start: dayjs(form.start_date).tz(tz),
  end: dayjs(form.end_date).tz(tz),
  shift_start_utc: form.start_date,
  shift_end_utc: form.end_date,
  editable: false,
  driver_id: form.driver?.id,
  driver_or_carrier_id: form.driver?.id ?? form.carrier_id ?? '',
  shift: type === 'AM Shift' ? 'am' : type === 'PM Shift' ? 'pm' : type,
  carrier_id: form.carrier_id,
  carrier_resource_num: form.carrier_resource_num,
})
